// eslint-disable-next-line
import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class Orcamento extends CoreBase implements IOrcamento {
  async backofficeOrcamentoEnviaOrcamento(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.backofficeOrcamentoEnviaOrcamento(params)
    return response
  }
}

interface IOrcamento extends ICoreBase {
  backofficeOrcamentoEnviaOrcamento(params: any): Promise<ResponseApi>
}

export {
  Orcamento,
  IOrcamento,
}
